export enum eSideDrawerContentType {
  Conversation,
}
